import { MULTI_INPUT_PLACEHOLDER_TEXTS } from './multiInputPlaceHolderTexts';

export const VALUE_TYPE_BEHAVIOR_MAP = {
  fixed: {
    placeHolder: 'Fixed',
    isCreatable: false,
  },
  empty: {
    placeHolder: MULTI_INPUT_PLACEHOLDER_TEXTS.EMPTY,
    isCreatable: false,
  },
  choose: {
    placeHolder: MULTI_INPUT_PLACEHOLDER_TEXTS.CHOOSE,
    isCreatable: false,
  },
  suggestions: {
    isCreatable: true,
  },
  any: {
    isCreatable: true,
  },
};
